<script>  
  import Saos from 'saos/src/Saos.svelte';
</script>

<div class="home_first ">
  <div class="container">
    <div class="row bg_dogs align-items-center">         
      <div class="col-lg-6 col-md-4 col-sm-12 order-md-2 text-center padding200">
          <img src="/img/images/green_dog_round.png" alt="dog coin" class="img-fluid"/>
      </div>
      
      <div class="col-lg-6 col-md-8 col-sm-12">
        <div class="common_home_section padding200">
          <h2>Dogs of Elon - A Utility Driven Cryptocurrency and NFT Project to Unify All Meme Communities</h2>
          <p>Multi-Faceted Play to Earn Gaming Platform, Robust Staking Incentives, Dynamic NFT Explorer, and Charitable Giving Work Together To Comprise an Ever-Growing Community Centric Ecosystem</p>
          <div class="btn_group width50">
            <a href="/#buy" class="fill_btn">How to Buy</a>
            <a href="/docs/Whitepaper.pdf" class="outline_btn" target="_blank">Read Whitepaper</a>
          </div>
        </div>
      </div>      
    </div>
  </div>
</div>
<div class="join_community herosocial">
  <div class="container">
    <div class="row justify-content-center">            
      <div class="col-xl-8 col-lg-8 col-md-11 col-sm-11 col-12">
        <div class="social_links">
          <div>
            <a href="https://twitter.com/KudoeOfficial" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/twitter_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/twitter_hover.svg" alt="icon"/></a>
          </div>
          <div>
            <a href="https://t.me/KudoeOfficial" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/telegram_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/telegram_hover.svg" alt="icon"/>
            </a>
          </div>
          <div>
            <a href="https://discord.gg/kudoe" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/discord_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/discord_hover.svg" alt="icon"/>
            </a>
          </div>
          <div>
            <a href="https://www.instagram.com/dogsofelonofficial" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/instagram_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/instagram_hover.svg" alt="icon"/>
            </a>
          </div>
          <div>
            <a href="https://kudoe.medium.com/" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/medium_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/medium_hover.svg" alt="icon"/>
            </a>
          </div>  
          <div>
            <a href="https://www.reddit.com/r/Kudoe/" target="_blank" rel="noreferrer">
              <img class="normal_social" src="/img/images/reddit_small.svg" alt="icon"/>
              <img class="hover_socail" src="/img/images/reddit_hover.svg" alt="icon"/>
            </a>
          </div>                              
        </div>
      </div>            
    </div>
  </div>
</div>

  